// Font Awesome
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";

// CSS
import "./styles/Common.css";
import "./styles/Drawer.css";
import "./styles/FooterArea.css";
import "./styles/Hero.css";
import "./styles/HeaderArea.css";
import "./styles/Layout.css";
import "./styles/Section/SectionPrice.css";
import "./styles/Section/SectionCase.css";
import "./styles/Section/SectionFaq.css";
import "./styles/Section/SectionNews.css";
import "./styles/Section/SectionMedia.css";
import "./styles/Atoms/Card.css";
import "./styles/Atoms/Button.css";
import "./styles/Atoms/Text.css";
import "./styles/Atoms/TextPhoneNumber.css";
import "./styles/Atoms/BreadCrumb.css";
import "./styles/Pages/Home.css";
import "./styles/Pages/Service.css";
import "./styles/Pages/Company.css";
import "./styles/Pages/Message.css";
import "./styles/Pages/Single.css";
import "./styles/Pages/Feature.css";
import "./styles/Pages/Contact.css";
import "./styles/Pages/Sitemap.css";
import "./styles/Pages/Information.css";
import "./styles/Pages/Access.css";
import "./styles/Pages/Recruit.css";

// JS
import "./libs/drawer";
import "./utils/viewport";
import "./utils/headerMenu";
import "./utils/scrollAnimation";
